import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-3xl px-5 pt-28 text-center sm:px-8">
      <p className="font-deva text-5xl text-terracotta">अ</p>
      <h1 className="mt-4 font-serif text-3xl text-ink">
        This path leads nowhere.
      </h1>
      <p className="mt-2 text-ink-faint">
        The page you’re looking for isn’t here.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block rounded-full border border-line-strong px-6 py-2 text-sm font-medium text-ink transition-colors hover:bg-paper-sunk"
      >
        Return home
      </Link>
    </div>
  );
}
